import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Table,
  DropdownButton,
  Dropdown,
  Row,
  Col,
  Form,
  Accordion,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import AddExpenseModal from "../../components/Modals/AddExpenseModal";
import { FaEdit, FaFileExport, FaPlus, FaTrashAlt } from "react-icons/fa";
import { BsThreeDotsVertical, BsDownload } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import Loader from "../../components/Loader";
import ExportModal from "../../components/Modals/ExportsModel/main";
import NoData from "../../components/NoData";
import { useCommonContext } from "../../utils/context";

import EpendiureViewModal from "../../components/Modals/HisstoryModals/ExpenditureViewModel";
import CommonButton from "../../components/CommonButton";
import StatusBadge from "../../components/StatusBadge";
import Pagination from "../../components/Pagination";
const TechExpenditure = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [expenses, setExpenses] = useState([]);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [editExpenseData, setEditExpenseData] = useState(null);
  const [showExportModal, setShowExportModal] = useState(false);
  const role = localStorage.getItem("role");
  const { toggled } = useCommonContext();
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const userId = localStorage.getItem("userId");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showViewModal, setShowViewModal] = useState(false);
  const userPermissions = localStorage.getItem("user_permissions");
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = expenses.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(expenses.length / itemsPerPage);

  useEffect(() => {
    if (userId) {
      fetchExpenses(userId, currentPage);
    }
  }, [userId, itemsPerPage, currentPage]);

  const fetchExpenses = async (userId, page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/expenses/?technician=${userId}&page=${page}`,
        {
          headers: HEADERS,
          params: {
            page: page,
            page_size: itemsPerPage,
          },
        },
      );
      if (response.data) {
        setExpenses(response.data.results);
        setTotalPages(Math.ceil(response.data.total_pages));
        setCurrentPage(page);
        setLoading(false);
      }
    } catch (error) {
      // toast.error("Failed to fetch expenses. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // const handleDeleteExpense = async (expenseId) => {
  //   try {
  //     await axios.delete(`${BASE_URL}/api/expenses/${expenseId}/`, {
  //       headers: HEADERS,
  //     });
  //     toast.success("Expense deleted successfully.");
  //     setExpenses(expenses.filter((expense) => expense.id !== expenseId));
  //   } catch (error) {
  //     toast.error("Failed to delete expense. Please try again.");
  //   }
  // };

  const handleFileDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(`${BASE_URL}/api/image_download/`, {
        method: "POST",
        headers: {
          ...HEADERS,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileUrl, fileName }),
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const openEditModal = (expense) => {
    setEditExpenseData(expense);
    setShowAddExpenseModal(true);
  };

  const openAddModal = () => {
    setEditExpenseData(null);
    setShowAddExpenseModal(true);
  };

  const handleCloseAddExpenseModal = () => {
    setShowAddExpenseModal(false);
    setEditExpenseData(null);
    fetchExpenses(userId);
  };

  const handleViewExpenditure = (expense) => {
    setEditExpenseData(expense);
    setShowViewModal(true);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex  container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">Expenses</h4>
        <div className="d-none d-md-flex align-items-center gap-2">
          {userPermissions.includes("expenses_add_expenses") && (
            <CommonButton className="uniform-button" onClick={openAddModal}>
              <FaPlus style={{ marginRight: "6px" }} /> Add
            </CommonButton>
          )}
          {(userPermissions.includes("expenses_can_export_all") ||
            userPermissions.includes("expenses_export")) && (
            <CommonButton
              className="uniform-button"
              onClick={() => setShowExportModal(true)}
              disabled={currentItems.length === 0}
            >
              <FaFileExport style={{ marginRight: "6px" }} /> Export
            </CommonButton>
          )}
        </div>

        <div className="d-md-none">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Actions</Accordion.Header>
              <Accordion.Body>
                <div className="d-flex flex-column gap-2">
                  {userPermissions.includes("expenses_add_expenses") && (
                    <CommonButton
                      className="uniform-button"
                      onClick={openAddModal}
                    >
                      <FaPlus style={{ marginRight: "6px" }} /> Add
                    </CommonButton>
                  )}
                  {(userPermissions.includes("expenses_can_export_all") ||
                    userPermissions.includes("expenses_export")) && (
                    <CommonButton
                      className="uniform-button"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                    >
                      <FaFileExport style={{ marginRight: "6px" }} /> Export
                    </CommonButton>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${expenses.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {expenses.length > 0 ? (
              <table className="table  tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ width: "150px" }}>Expense ID</th>
                    {role !== "sales" && (
                      <th style={{ width: "150px" }}>Ticket ID</th>
                    )}
                    <th style={{ width: "200px" }}>Date</th>
                    <th style={{ width: "300px" }}>Expense Type</th>
                    <th style={{ width: "300px" }}>From</th>
                    <th style={{ width: "300px" }}>To</th>
                    <th style={{ width: "200px" }}>Expense Date</th>
                    <th style={{ width: "150px" }}>Amount</th>
                    <th style={{ width: "150px" }}>Approved Amount</th>
                    <th style={{ width: "400px" }}>Description</th>
                    <th style={{ width: "200px" }}>Status</th>
                    <th style={{ width: "400px" }}>Remark</th>
                    <th style={{ width: "200px" }}>Image</th>
                    <th style={{ width: "200px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.map((expense) => (
                    <tr
                      key={expense.id}
                      className="tbody"
                      onClick={() => handleViewExpenditure(expense)}
                    >
                      <td>
                        <div title={expense.id} className="tdsubject">
                          {expense.id || "—"}
                        </div>
                      </td>
                      {role !== "sales" && (
                        <td>
                          <div title={expense.ticket?.id} className="tdsubject">
                            {expense.ticket?.id || "—"}
                          </div>
                        </td>
                      )}
                      <td>
                        <div title={expense.expense_date} className="tdsubject">
                          {expense.expense_date || "—"}
                        </div>
                      </td>
                      <td>
                        <div title={expense.expense_type} className="tdsubject">
                          {expense.expense_type || "—"}
                        </div>
                      </td>
                      <td>
                        <div title={expense.from_field} className="tdsubject">
                          {expense.from_field || "—"}
                        </div>
                      </td>
                      <td>
                        <div title={expense.to} className="tdsubject">
                          {expense.to || "—"}
                        </div>
                      </td>
                      <td>
                        <div title={expense.expense_date} className="tdsubject">
                          {expense.expense_date || "—"}
                        </div>
                      </td>
                      <td>
                        <div title={expense.amount} className="tdsubject">
                          {expense.amount || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={expense.approvedAmount || "-"}
                          className="tdsubject"
                        >
                          {expense.approvedAmount || "-"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={expense.description || "—"}
                          className="tdsubject"
                        >
                          {expense.description || "—"}
                        </div>
                      </td>

                      <td>
                        <StatusBadge status={expense.status} />
                      </td>

                      <td>
                        <div
                          title={
                            expense.status === "Approved" &&
                            expense.approvedRemark
                              ? expense.approvedRemark
                              : expense.status === "Rejected" &&
                                  expense.rejectedRemark
                                ? expense.rejectedRemark
                                : expense.status === "Paid" &&
                                    expense.paidRemark
                                  ? expense.paidRemark
                                  : "None"
                          }
                          className="tdsubject"
                        >
                          {expense.status === "Approved" &&
                          expense.approvedRemark
                            ? expense.approvedRemark
                            : expense.status === "Rejected" &&
                                expense.rejectedRemark
                              ? expense.rejectedRemark
                              : expense.status === "Paid" && expense.paidRemark
                                ? expense.paidRemark
                                : "None"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            expense.image
                              ? expense.image.split("/").pop()
                              : "No Image"
                          }
                          className="tdsubject d-flex align-items-center "
                        >
                          {expense.image ? (
                            <div className="d-flex align-items-center ">
                              <span
                                className="text-truncate"
                                style={{ maxWidth: "120px" }}
                              >
                                {expense.image.split("/").pop()}
                              </span>
                              <Button
                                variant="link"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleFileDownload(
                                    expense.image,
                                    expense.image.split("/").pop(),
                                  );
                                }}
                                className="p-0"
                              >
                                <BsDownload
                                  size={14}
                                  className="text-primary"
                                />
                              </Button>
                            </div>
                          ) : (
                            <span className="text-muted">No Image</span>
                          )}
                        </div>
                      </td>

                      <td title="Edit">
                        {expense.status === "Submitted" &&
                          userPermissions.includes(
                            "expenses_change_expenses",
                          ) && (
                            <FaEdit
                              className="me-3 cursor-pointer text-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditModal(expense);
                              }}
                            />
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="expenses"
        technicianId={userId}
      />
      {showAddExpenseModal && (
        <AddExpenseModal
          show={showAddExpenseModal}
          handleClose={handleCloseAddExpenseModal}
          technicianId={userId}
          onAddExpense={() => fetchExpenses(currentPage)}
          expenseData={editExpenseData}
        />
      )}
      <EpendiureViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        ependitureId={editExpenseData?.id}
        ependiture={editExpenseData}
      />
    </div>
  );
};

export default TechExpenditure;
